import { Box, Divider, Typography } from "@mui/material";
import { Fragment, type Dispatch, type FC } from "react";
import type { NoNullFields } from "../../../../server/supabase/base-supabase-service";
import type { UsableAccountPersonField } from "../../server/supabase-segment-field-service";
import { ConditionRow } from "./condition-row/condition-row";
import type { SegmentManagerAction, SegmentReducerState } from "./reducer/actions";
import type { Segment } from "../../types/segment-schema";

interface ConditionListProps {
  segment: Segment["segment_json"]["segments"][number];
  segmentIndex: number;
  dispatch: Dispatch<SegmentManagerAction<Segment>>;
  segmentFields: NoNullFields<UsableAccountPersonField>[];
  errors: SegmentReducerState<Segment>["errors"];
  disabled: boolean;
  recipientTypeKey?: string;
}

export const ConditionList: FC<ConditionListProps> = ({
  segment,
  segmentIndex,
  dispatch,
  segmentFields,
  errors,
  disabled,
  recipientTypeKey,
}) => {
  return (
    <>
      {segment.conditions.map((condition, conditionIndex) => (
        <Fragment key={conditionIndex}>
          <ConditionRow
            groupIndex={segmentIndex}
            conditionIndex={conditionIndex}
            condition={condition}
            dispatch={dispatch}
            segmentFields={segmentFields}
            errors={errors}
            allowDelete={segment.conditions.length > 1}
            disabled={disabled}
            recipientTypeKey={recipientTypeKey}
          />
          {conditionIndex < segment.conditions.length - 1 && (
            <Divider textAlign="left">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  m: "0 auto",
                  px: 1,
                  outlineColor: "divider",
                  outlineWidth: 1,
                  outlineStyle: "solid",
                  outlineRadius: 1,
                }}
              >
                <Typography variant="overline">
                  {segment.operation === "AND" ? "And" : "Or"}
                </Typography>
              </Box>
            </Divider>
          )}
        </Fragment>
      ))}
    </>
  );
};
